import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { JurisdictionsEnum } from '@libs/backend-common';
import { FadeBottomToTopContainer } from './styles';
const FadeBottomToTop = ({ children, className, currentJurisdiction, isOpen, }) => {
    const [isVisible, setVisible] = useState(false);
    const IS_GLOBAL_JURISDICTION = currentJurisdiction === JurisdictionsEnum.UA;
    const [isReadyToDisplay, setIsReadyToDisplay] = useState(IS_GLOBAL_JURISDICTION);
    const fadeContainer = useRef(null);
    useEffect(() => {
        const observedRef = fadeContainer.current;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                setVisible(entry.isIntersecting);
                if (entry.intersectionRatio > 0 && fadeContainer.current) {
                    observer.unobserve(fadeContainer.current);
                }
            });
        });
        if (fadeContainer.current)
            observer.observe(fadeContainer.current);
        return () => {
            if (observedRef)
                observer.unobserve(observedRef);
        };
    }, [isOpen]);
    useEffect(() => {
        if (!isOpen) {
            setIsReadyToDisplay(true);
        }
    }, [isOpen]);
    return (_jsx(FadeBottomToTopContainer, { ref: fadeContainer, className: className, isVisible: isVisible && isReadyToDisplay, children: children }));
};
export default FadeBottomToTop;
//# sourceMappingURL=FadeBottomToTop.js.map